
import { get_customer } from '@/http';

/**
 * 获取经销商数据
 */
export function getDealerListPage(params) {
  return get_customer({
    url: `/beijing-info-vehicle/exterior/h5/vehicleModelSetting/getDealerListPage`,
    params,
    hasLoading: true,
  });
}

export function getDealer4SListPage(params) {
  return get_customer({
    url: `/beijing-info-vehicle/exterior/h5/dealer/getYunYangDealerListPage`,
    params,
    hasLoading: false,
  });
}
